import { Grid as ChakraGrid } from '@chakra-ui/react'

export const Grid = ChakraGrid
